import {ChangeDetectionStrategy, Component, Signal} from "@angular/core";
import {navParam} from "../../navigation/navigation-params";
import {Page} from "../../navigation/page";
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';

@Component({
    selector: "woa-legal-page",
    templateUrl: "./legal-page.component.html",
    styleUrl: "./legal-page.component.scss",
    providers: [{provide: Page, useExisting: LegalPageComponent}],
    imports: [
        ModalPageLayoutComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegalPageComponent extends Page {
    public readonly display: Signal<"terms" | "privacy"> = navParam.required<"terms" | "privacy">("display");
}
